import React from 'react';
import './Square.css';

const Square = ({value, selectSquare, x, y}) => {
  const trigger = (event) => {
    if (value == null) {
      selectSquare(x, y);
    }
  }

  return (
    <button className="square" x={x} y={y} onClick={trigger}> 
      {value}
    </button>   
  )
}

export default Square;